  export enum ProcessLockedEnum {
    CALCUL_ARTICLES_PREFERES = 'CALCUL_ARTICLES_PREFERES',
    CALCUL_PRIX_PLATS = 'CALCUL_PRIX_PLATS',
    IMPORT_XLS_CATALOGUE_ACHAT = 'IMPORT_XLS_CATALOGUE_ACHAT'
  }
